// Avis clients et réalisations réels. Laisser vide tant qu'aucun contenu vérifié n'est fourni :
// la section « Ils nous font confiance » n'est affichée que si l'un des deux tableaux contient des éléments.
//
// Format AVIS : { auteur: 'Prénom N.', role: 'Artisan, Montreuil (93)', note: 5, texte: '…', source: 'Google', date: '2026-05' }
// Format REALISATIONS : { titre: 'Évacuation gravats – Pavillon', lieu: 'Argenteuil (95)', benne: '10m³ Gravats', image: '/realisations/xxx.webp', date: '2026-05' }

export const AVIS = [];

export const REALISATIONS = [];
